// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { Box, Typography } from '@mui/material';
import FormDialog from '../../../components/Dialog/FormDialog';
import { InstructedRow } from './types';

interface CancelInstructDialogProps {
  open: boolean;
  onClose: () => void;
  row?: InstructedRow;
  onCancel: (r: InstructedRow) => Promise<void>;
}

export const CancelInstructDialog: React.FC<CancelInstructDialogProps> = ({
  open,
  onClose,
  onCancel,
  row,
}) => {
  const handleSubmit = React.useCallback(() => {
    if (onCancel && row) {
      return onCancel(row).finally(() => {
        onClose();
      });
    }
    onClose();
    return Promise.resolve();
  }, [onClose, onCancel, row]);
  return (
    <FormDialog
      open={open}
      submitButtonSxProps={{ color: 'error' }}
      title={
        <Typography fontWeight="bold" variant="h6" color="error">
          Cancel Instruction
        </Typography>
      }
      onCancel={onClose}
      onSubmit={handleSubmit}
      submitName="Continue"
    >
      <Box>
        <Typography variant="body2">
          Cancelling this will unlock your allocated funds (if you have already allocated them).
        </Typography>
        <Typography sx={{ mt: 2 }} variant="body2">
          Would you like to continue?
        </Typography>
      </Box>
    </FormDialog>
  );
};
